import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';

export default function PrivacyPolicy() {
  pageTitle('Chính sách bảo mật');

  return (
    <>
      <BannerSectionStyle3
        bgUrl='/images/about/banner_bg.svg'
        imgUrl='/images/about/banner_img.png'
        title='Chính sách bảo mật'
        subTitle='Nha khoa Tiến Đức cam kết bảo vệ thông tin cá nhân của Quý khách hàng khi sử dụng website và dịch vụ của chúng tôi.'
      />
      <Section topMd={100} topLg={80} topXl={60} bottomMd={100} bottomLg={80} bottomXl={60}>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-10 offset-lg-1'>
              <div className='cs_privacy_policy cs_heading_color'>
                <p className='cs_fs_18'>
                  Nha khoa Tiến Đức (“chúng tôi”) tôn trọng và cam kết bảo vệ sự
                  riêng tư của Quý khách. Chính sách bảo mật này mô tả cách
                  chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ thông tin cá
                  nhân mà Quý khách cung cấp khi truy cập website hoặc sử dụng
                  dịch vụ nha khoa của chúng tôi.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  1. Mục đích thu thập thông tin
                </h3>
                <p className='cs_fs_18'>
                  Chúng tôi thu thập thông tin cá nhân của Quý khách nhằm các
                  mục đích sau:
                </p>
                <ul className='cs_fs_18'>
                  <li>Hỗ trợ đặt lịch hẹn khám và điều trị nha khoa.</li>
                  <li>
                    Tư vấn dịch vụ, giải đáp thắc mắc và chăm sóc khách hàng
                    trước, trong và sau quá trình điều trị.
                  </li>
                  <li>
                    Gửi thông tin khuyến mãi, tin tức, cập nhật dịch vụ mới (chỉ
                    khi Quý khách đồng ý nhận).
                  </li>
                  <li>
                    Nâng cao chất lượng dịch vụ và cải thiện trải nghiệm người
                    dùng trên website.
                  </li>
                  <li>
                    Tuân thủ các quy định pháp luật hiện hành liên quan đến hoạt
                    động khám chữa bệnh.
                  </li>
                </ul>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  2. Phạm vi thu thập thông tin
                </h3>
                <p className='cs_fs_18'>
                  Các thông tin Quý khách có thể cung cấp cho chúng tôi bao
                  gồm:
                </p>
                <ul className='cs_fs_18'>
                  <li>Họ và tên, giới tính, ngày tháng năm sinh.</li>
                  <li>
                    Thông tin liên hệ: số điện thoại, địa chỉ email, địa chỉ nhà
                    riêng.
                  </li>
                  <li>
                    Thông tin về tình trạng sức khỏe răng miệng, tiền sử điều
                    trị (khi cần thiết cho việc thăm khám).
                  </li>
                  <li>
                    Nội dung tin nhắn, yêu cầu tư vấn mà Quý khách gửi đến chúng
                    tôi.
                  </li>
                </ul>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  3. Thời gian lưu trữ thông tin
                </h3>
                <p className='cs_fs_18'>
                  Dữ liệu cá nhân của Quý khách sẽ được lưu trữ cho đến khi có
                  yêu cầu hủy bỏ. Trong các trường hợp còn lại, thông tin cá
                  nhân sẽ được bảo mật và lưu trữ trên hệ thống máy chủ của Nha
                  khoa Tiến Đức.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  4. Những người có thể tiếp cận thông tin
                </h3>
                <p className='cs_fs_18'>
                  Thông tin cá nhân của Quý khách sẽ được tiếp cận bởi các đối
                  tượng sau đây:
                </p>
                <ul className='cs_fs_18'>
                  <li>
                    Đội ngũ bác sĩ, nhân viên của Nha khoa Tiến Đức có trách
                    nhiệm trực tiếp phục vụ Quý khách.
                  </li>
                  <li>
                    Các đơn vị cung cấp dịch vụ hỗ trợ (lưu trữ dữ liệu, gửi
                    email, vận chuyển…) với cam kết bảo mật tương đương.
                  </li>
                  <li>
                    Cơ quan nhà nước có thẩm quyền khi có yêu cầu theo quy định
                    của pháp luật.
                  </li>
                </ul>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  5. Cam kết bảo mật thông tin
                </h3>
                <p className='cs_fs_18'>
                  Chúng tôi cam kết không mua bán, trao đổi hay tiết lộ thông
                  tin cá nhân của Quý khách cho bên thứ ba khi chưa có sự đồng
                  ý, trừ các trường hợp được pháp luật yêu cầu. Thông tin được
                  bảo mật tuyệt đối bằng các biện pháp kỹ thuật và quản lý phù
                  hợp nhằm ngăn chặn việc truy cập, sử dụng hoặc tiết lộ trái
                  phép.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  6. Quyền của khách hàng
                </h3>
                <p className='cs_fs_18'>
                  Quý khách có quyền kiểm tra, cập nhật, điều chỉnh hoặc yêu cầu
                  xóa thông tin cá nhân của mình. Để thực hiện, vui lòng liên hệ
                  với chúng tôi qua thông tin bên dưới.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  7. Thông tin liên hệ
                </h3>
                <p className='cs_fs_18'>
                  Mọi thắc mắc liên quan đến Chính sách bảo mật, Quý khách vui
                  lòng liên hệ:
                </p>
                <ul className='cs_fs_18'>
                  <li>
                    <b>Nha khoa Tiến Đức</b>
                  </li>
                  <li>Hotline: 0968 60 8881 – 0925 247 365</li>
                  <li>
                    Email:{' '}
                    <a href='mailto:hellocallcenter@gmail.com'>
                      hellocallcenter@gmail.com
                    </a>
                  </li>
                </ul>

                <p className='cs_fs_18 mt-5'>
                  Chính sách bảo mật này có thể được cập nhật theo từng thời
                  điểm. Mọi thay đổi sẽ được thông báo trên website của chúng
                  tôi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
